export const ALTERNATE_STEPS = {
    ProspectInfluencer: 'prospect_influencer',
    BedroomCount: 'bedroom_count'
};